/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import { Button } from 'antd'
import React, { useCallback, useEffect, useState } from 'react'
import { useGetFileBreadcrumbsQuery, useLazyGetFilesV2Query } from '../../api/v2/filesV2'
import { useMyContext } from '../../context/context'
import { useSettingsV3 } from '../../hooks/useSettingsV3'
import Filters from './Filters'
import Gallery from './Gallery'
import FilesHTML from './HTML'

export default function FilesScreen() {
  const [keys, setKeys] = useState({})
  const [files, setFiles] = useState({})
  const [hasMores, setHasMores] = useState({})
  const [filters, setFilters] = useState({})

  const { myContext } = useMyContext()
  const { settings } = useSettingsV3()

  const { data } = useGetFileBreadcrumbsQuery({ ...myContext, ...filters })
  const [fetchFiles, { isFetching }] = useLazyGetFilesV2Query()

  const fetchNextFiles = useCallback(
    breadcrumbId => {
      const prevFiles = files[breadcrumbId] || []

      fetchFiles({ ...myContext, breadcrumbId, offset: prevFiles.length, limit: 10, ...filters })
        .unwrap()
        .then(({ files: newFiles, hasMore }) => {
          setFiles(prev => ({ ...prev, [breadcrumbId]: [...prevFiles, ...newFiles] }))
          setHasMores(prev => ({ ...prev, [breadcrumbId]: hasMore }))
        })
    },
    [fetchFiles, files, filters, myContext]
  )

  useEffect(() => {
    const breadcrumbOpenIds = Object.entries(keys)
      .filter(([, v]) => v)
      .map(([k]) => k)
    const breadcrumbId = breadcrumbOpenIds.find(f => !files[f])
    if (breadcrumbId) {
      fetchNextFiles(breadcrumbId)
    }
  }, [fetchNextFiles, files, keys])

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
      <FilesHTML />
      <Filters
        contentTypes={data?.contentTypes}
        onChange={f => {
          setFilters(f)
          // setKeys({})
          setFiles({})
          setHasMores({})
        }}
      />
      {data?.breadcrumbs.map(b => (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
          <div
            style={{
              background: settings?.bgPrimaryColor,
              color: 'white',
              padding: '10px 16px',
              borderRadius: 16,
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              cursor: 'pointer',
            }}
            onClick={() => setKeys(prev => ({ ...prev, [b.id]: !prev[b.id] }))}
          >
            <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
              <div style={{ fontSize: 20, fontWeight: 500 }}>{b.label || 'Autres'}</div>
              <div style={{ fontSize: 14, marginTop: 2, fontWeight: 500 }}>{`| ${b.total} fichier(s) disponible(s)`}</div>
            </div>
            <div style={{ fontSize: 20, marginBottom: 2 }}>{keys[b.id] ? '-' : '+'}</div>
          </div>
          {keys[b.id] && (
            <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
              <Gallery files={files[b.id]} hasMore={hasMores[b.id]} fetchNextFiles={() => fetchNextFiles(b.id)} />
              {hasMores[b.id] && (
                <Button type="primary" onClick={() => fetchNextFiles(b.id || 'null')} loading={isFetching}>
                  Afficher plus
                </Button>
              )}
            </div>
          )}
        </div>
      ))}
    </div>
  )
}
